import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";

const FETCH_GTM_PROJECTS_FOR_PRODUCT_LINE = gql`
  query FETCH_GTM_PROJECTS_FOR_PRODUCT_LINE {
    gtmProjects(activeOnly: true) {
      total
      results {
        id
        name
        state
        logisticsData
        logisticsConfirmedAt
      }
    }
  }
`;

const GTMProjectSelectorView = ({ onSelect }) => {
  const { loading, error, data } = useQuery(
    FETCH_GTM_PROJECTS_FOR_PRODUCT_LINE,
  );
  const [searchText, setSearchText] = useState("");

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const projects = [...data.gtmProjects.results]
    .filter((project) => searchByProp(project, ["name"], searchText))
    .sort((a, b) => a.name.localeCompare(b.name, "en"));

  return (
    <div>
      <SearchBar
        placeholder="Search by project name"
        value={searchText}
        onChange={setSearchText}
        autoFocus
      />
      <div className="mt-3 divide-y dark:divide-gray-700">
        {projects.length === 0 ? (
          <div className="py-3 text-sm opacity-70">No active GTM projects.</div>
        ) : (
          projects.map((project) => (
            <button
              key={project.id}
              type="button"
              className="w-full text-left py-2 hover:text-sky-600"
              onClick={() => onSelect(project)}
            >
              <div className="font-semibold">{project.name}</div>
              <div className="text-xs opacity-70">{project.state}</div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default GTMProjectSelectorView;
